import React, { useState, useEffect, useRef } from 'react';
import { __ } from '@wordpress/i18n';
import { useParams } from 'react-router-dom';
import { is, isEmpty, isNil } from 'ramda';
import 'quill/dist/quill.core.css';

// store
import { storeSet, useStoreValue } from '../../store';

// tools
import getDateFromISOstring from '../../helpers/getDateFromISOstring';

// components
import { Skeleton } from 'primereact/skeleton';
import { Button } from 'primereact/button';
import BandoService from '../../service/bando-service';
import { Messages } from 'primereact/messages';
import set404FromErrorResponse from '../../helpers/set404FromErrorResponse';
import renderHtmlContent from '../../helpers/renderHtmlContent';

const BandoViewPreInstructor = () => {
    const isAsyncRequest = useStoreValue('isAsyncRequest');
    const { id } = useParams();
    const [data, setData] = useState({});
    const [newQuestion, setNewQuestion] = useState('');
    const bandoMsgs = useRef(null);

    const getCallback = (data) => {
        if (data.status === 'SUCCESS') {
            setData(getFormattedBandiData(data.data));
        }
        storeSet('unsetAsyncRequest');
    }

    const errGetCallback = (data) => {
        if (bandoMsgs.current && data.message) {
            bandoMsgs.current.show([
                {
                    sticky: true, severity: 'error', summary: '',
                    detail: data.message,
                    closable: true
                }
            ]);
        }
        set404FromErrorResponse(data);
        storeSet('unsetAsyncRequest');
    }

    const getFormattedBandiData = (data) => {
        data.dates = data.dates.map(v => is(String, v) ? new Date(v) : (v ? v : ''));
        return data;
    };

    useEffect(() => {
        const parsed = parseInt(id)
        const bandoId = !isNaN(parsed) ? parsed : 0;

        BandoService.getBando(bandoId, getCallback, errGetCallback);
    }, [id]);

    return (
        <div className="appPage">
            {!isAsyncRequest && !isEmpty(data)
                ? <div className="appPage__pageHeader">
                    <h1>{data.name}</h1>
                    <p>
                        {__('Data:', 'htr')}
                        <span>{getDateFromISOstring(data.createdDate)}</span>
                    </p>
                </div>
                : <>
                    <Skeleton width="20%" height="1rem" className="mb-2"></Skeleton>
                    <Skeleton width="100%" height="2rem" className="mb-8"></Skeleton>
                </>}

            <div className="appPage__spacer"></div>
            <Messages ref={bandoMsgs}/>

            {!isAsyncRequest && !isEmpty(data)
                ? <div className="appPage__content">
                    {!isEmpty(data.images)
                        ? <picture className="appPageSection__hero">
                            <source srcSet={data.images[0] ? data.images[0].filePath : ''}/>
                            <img src={data.images[0] ? data.images[0].filePath : ''} alt={data.name}/>
                        </picture> : null}

                    <div className="appPageSection__withBorder">
                        <h2>{__('Descrizione breve', 'htr')}</h2>
                        <div className="ql-editor">
                            {renderHtmlContent(data.descriptionShort)}
                        </div>
                    </div>

                    <div className="appPageSection__withBorder">
                            <h2>{__('Descrizione dettagliata', 'htr')}</h2>
                            <div className="ql-editor">
                                {renderHtmlContent(data.descriptionLong)}
                            </div>
                        </div>

                    <div className="appPageSection__withBorder">
                            <h2>{__('Requisiti di Partecipazione', 'htr')}</h2>
                            <div className="row rowContent">
                                <ul>
                                    {data.aimedTo.map((o, i) => <li key={i}>
                                        {o.value}
                                    </li>)}
                                </ul>
                            </div>
                        </div>

                    <div className="appPageSection__withBorder">
                        <h2>{__('Documentazione richiesta', 'htr')}</h2>
                        <div className="ql-editor">
                            {renderHtmlContent(data.documentationRequested)}
                        </div>
                    </div>

                    {/*<div className="appPageSection">
                        <h2>{__('Compila', 'htr')}</h2>
                        <div className="appPageSection__actions">
                            <Button
                                type="button"
                                outlined
                                onClick={() => {
                                }}
                                label={__('Scarica Form Completo', 'htr')}
                                icon="pi pi-download" iconPos="right"/>
                            <Button
                                type="button"
                                outlined
                                onClick={() => {
                                }}
                                label={__('Scarica Modulistica', 'htr')}
                                icon="pi pi-download" iconPos="right"/>
                            <Button
                                type="button"
                                disabled={true}
                                onClick={() => {
                                }}
                                label={__('Presenta Domanda', 'htr')}
                                icon="pi pi-save" iconPos="right"/>
                            <Button
                                type="button"
                                outlined
                                rounded
                                disabled={true}
                                onClick={() => {}}
                                label={__('Aggiungi a preferiti', 'htr')}
                                icon="pi pi-heart" iconPos="left"/>
                        </div>
                    </div>*/}

                    <div className="appPageSection__withBorder">
                        <h2>{__('Contatti per Assistenza', 'htr')}</h2>
                        <div className="row rowContent">
                            <p>Email: {data.email}</p>
                            {!isNil(data.phoneNumber) ?
                                <p>{__('Telefono', 'htr')}: +39 {data.phoneNumber}</p> : null}
                        </div>
                    </div>
                </div>
                : <>
                    <Skeleton width="20%" height="1rem" className="mb-2"></Skeleton>
                    <Skeleton width="100%" height="2rem" className="mb-8"></Skeleton>
                    <Skeleton width="20%" height="1rem" className="mb-2"></Skeleton>
                    <Skeleton width="100%" height="4rem" className="mb-8"></Skeleton>
                    <Skeleton width="20%" height="1rem" className="mb-2"></Skeleton>
                    <Skeleton width="100%" height="2rem" className="mb-8"></Skeleton>
                    <Skeleton width="20%" height="1rem" className="mb-2"></Skeleton>
                    <Skeleton width="100%" height="4rem"></Skeleton>
                </>}
        </div>
    )

}

export default BandoViewPreInstructor;